import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '@/contexts/AuthContext';
import Logo from '@/components/Logo';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    const res = await login(form.email, form.password);
    setLoading(false);
    if (res.ok) nav('/dashboard');
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full" style={{ background: 'radial-gradient(closest-side, rgba(0,255,102,0.2), transparent)' }} />
      </div>
      <div className="relative max-w-md mx-auto px-6 py-14">
        <Link to="/" className="inline-block mb-10" data-testid="login-logo"><Logo size={28} /></Link>
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="card-tech rounded-lg p-8">
          <div className="label-sm mb-2">Welcome back</div>
          <h1 className="font-display text-3xl">Sign in to Traders Spring</h1>
          <p className="text-sm text-zinc-500 mt-1">Prove your edge. Earn performance rewards.</p>

          <form onSubmit={onSubmit} className="space-y-3 mt-6" data-testid="login-form">
            <div>
              <div className="label-xs mb-1">Email</div>
              <input className="input-tech" type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="you@email.com" data-testid="login-email" />
            </div>
            <div>
              <div className="label-xs mb-1 flex items-center justify-between">
                <span>Password</span>
                <Link to="/forgot" className="normal-case tracking-normal text-zinc-400 hover:text-[#00ff66]" data-testid="login-forgot-link">Forgot?</Link>
              </div>
              <input className="input-tech" type="password" required minLength={6} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="••••••••" data-testid="login-password" />
            </div>
            {error && <div className="text-sm text-[#ff3366]" data-testid="login-error">{error}</div>}
            <button disabled={loading} type="submit" className="btn-primary w-full justify-center" data-testid="login-submit">
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <p className="text-xs text-zinc-500 mt-5 text-center">
            New here? <Link to="/register" className="text-white hover:text-[#00ff66]" data-testid="login-go-register">Create an account</Link>
          </p>
        </motion.div>
      </div>
    </div>
  );
}
